<div class="associated-assessment">
	<app-only-table-generator
		*ngIf="tableGenInput"
		[tableInput]="tableGenInput"
		[tableData]="associatedAssessmentData"
	></app-only-table-generator>
</div>
